import { Create, SimpleForm, TextInput, BooleanInput, ReferenceInput, AutocompleteInput } from "react-admin";

const CreateVersionObject = ({ mode }) => {
  let title;
  let isPage;

  switch (mode) {
    case "page":
      title = "Създаване на страница";
      isPage = true;
      break;
    case "component":
      title = "Създаване на компонент";
      isPage = false;
      break;
    default:
  }

  return (
    <Create
      title={title}
      mutationOptions={{ meta: { useFormData: false } }}
    >
      <SimpleForm>
        <TextInput
          required
          source="name"
          label="Име"
        />
        {isPage && (
          <>
            <TextInput
              required
              source="route"
              label="Адрес"
            />

            <BooleanInput
              source="isInternal"
              label="Вътрешен път?"
            />
            <ReferenceInput
              reference={"languages-cms"}
              source="languageId"
              queryOptions={{ meta: { mixed_provider: true } }}
            >
              <AutocompleteInput
                label="Език"
                filterToQuery={q => ({ language: q })}
                optionText={"language"}
              />
            </ReferenceInput>
            <p className="">SEO</p>
            <BooleanInput
              defaultValue={true}
              source="hasIndex"
              label="Индексиране?"
            />

            <TextInput
              source="title"
              label="Мета заглавие"
            />

            <TextInput
              source="description"
              label="Мета описание"
            />

            <TextInput
              source="canonicalTag"
              label="Каноникал таг"
            />
          </>
        )}
      </SimpleForm>
    </Create>
  );
};

export default CreateVersionObject;
